import { Injectable } from '@angular/core';

import { select, Store, Action } from '@ngrx/store';

import * as fromProvider from './provider.reducer';
import * as ProviderSelectors from './provider.selectors';
import { getTermsOfUse } from './provider.selectors';

@Injectable()
export class ProviderFacade {
	data$ = this.store.pipe(select(ProviderSelectors.getData));
	messageCount$ = this.store.pipe(select(ProviderSelectors.getCountUnreadMessage));
	systemTemplates$ = this.store.pipe(select(ProviderSelectors.getSystemTemplates));
	customTemplates$ = this.store.pipe(select(ProviderSelectors.getCustomTemplates));
	resourceList$ = this.store.pipe(select(ProviderSelectors.getResources));
	employeeList$ = this.store.pipe(select(ProviderSelectors.getEmployeeResources));
	employeeResourcesObj$ = this.store.pipe(select(ProviderSelectors.getEmployeeResourcesObj));
	roomList$ = this.store.pipe(select(ProviderSelectors.getRoomResources));
	roomResourcesObj$ = this.store.pipe(select(ProviderSelectors.getRoomResourcesObj));
	deviceList$ = this.store.pipe(select(ProviderSelectors.getDeviceResources));
	deviceResourcesObj$ = this.store.pipe(select(ProviderSelectors.getDeviceResourcesObj));
	calendarResources$ = this.store.pipe(select(ProviderSelectors.getCalendarResources));
	settings$ = this.store.pipe(select(ProviderSelectors.getSettings));
	settingsCalendar$ = this.store.pipe(select(ProviderSelectors.getSettingsCalendar));
	externalSource$= this.store.pipe(select(ProviderSelectors.getExternalSource));
	loading$ = this.store.pipe(select(ProviderSelectors.getProviderLoading));
	error$ = this.store.pipe(select(ProviderSelectors.getProviderError));
	legalNotice$ = this.store.pipe(select(ProviderSelectors.getLegalNotice));
	privacy$ = this.store.pipe(select(ProviderSelectors.getPrivacy));
	termsOfUse$ = this.store.pipe(select(ProviderSelectors.getTermsOfUse));

	constructor(private store: Store<fromProvider.ProviderPartialState>) {
	}

	dispatch(action: Action) {
		this.store.dispatch(action);
	}
}
